/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".status-cell{white-space:normal!important;word-break:break-word;vertical-align:top;min-width:8rem;max-width:30rem}"];
export { styles as styles };
